import { MutableRefObject, useRef, useEffect } from "react";

export function useTimeoutRef(): MutableRefObject<
  ReturnType<typeof setTimeout> | undefined
> {
  const ref = useRef<ReturnType<typeof setTimeout>>();

  // Clean up on unmount.
  useEffect(() => () => ref.current && clearTimeout(ref.current), []);

  return ref;
}
